import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/**
 * A native `<select>` dressed as the design system's input: on a phone it opens the platform's own
 * picker, which suits short fixed lists (document type, payer, tax mode) better than a popover.
 */
export function NativeSelect({ className, ...props }: ComponentProps<'select'>) {
  return (
    <select
      className={cn(
        'min-h-[38px] w-full min-w-0 rounded-md border border-input bg-card px-3 py-2 text-base text-foreground md:text-sm',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none',
        'aria-invalid:border-destructive',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
